/**
 * The languages the app can actually render.
 *
 * A language only works if its translation bundle ships with the build, so this
 * list is derived from what `src/i18n` loads rather than being configured
 * elsewhere. Adding a locale is one import in the i18n setup plus one entry
 * here; nothing else needs touching.
 *
 * This replaces two hand-maintained copies of the same two-item array, one in
 * the onboarding language screen and one in the settings profile tab, which
 * were free to drift apart.
 */

export interface AppLanguage {
  id: string;
  /** Endonym: a language is easier to recognise written in itself. */
  name: string;
  flag: string;
}

export const APP_LANGUAGES: readonly AppLanguage[] = [
  { id: 'en', name: 'English', flag: '🇬🇧' },
  { id: 'id', name: 'Bahasa Indonesia', flag: '🇮🇩' },
];

export const DEFAULT_LANGUAGE = 'en';

export const getLanguageOptions = () =>
  APP_LANGUAGES.map(({ id, name }) => ({ value: id, label: name }));

export const isSupportedLanguage = (value?: string | null): boolean =>
  !!value && APP_LANGUAGES.some((language) => language.id === value);
